import React from 'react';

import styles from './styles.module.scss';

const Errors = ({ errors }) => {
  return (
    <div className={styles.errorsWrapper}>
      {errors.map((error, key) => <div key={key}>{error}</div>)}
    </div>
  );
};

export default Errors;
